import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchBrevoList() {
    try {
        const result = yield call(AxiosCall, '/brevo/get_all_contactlists/');
        yield put(actions.fetchBrevoListSuccess(result.data.results));
    } catch (e) {
        yield put(actions.fetchBrevoListFailure(e));
    }
}

export default function* rootSaga() {
    yield all([
        // watchers list
        takeLatest(actions.FETCH_BREVO_LIST.REQUEST, fetchBrevoList),
    ])
}